import { render, staticRenderFns } from "./arriveDialog.vue?vue&type=template&id=1c29ad9d&"
import script from "./arriveDialog.vue?vue&type=script&lang=js&"
export * from "./arriveDialog.vue?vue&type=script&lang=js&"
import style0 from "./arriveDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports